import { TenantConfig } from '@/types/TenantConfig'

const white = '#ffffff'
const grey = '#3f4d51'
const orange = '#faa334'
const pink = '#d35f6e'
const teal = '#348591'

export const artisttix: TenantConfig = {
  logo: 'assets/artisttix/static/logo.svg',

  themeOptions: {
    primaryColor: orange,
    secondaryColor: pink,
    logoHeight: '55px',
    headerHeight: '100px',
    headerBackground: teal,
    footerBackgroundColor: grey,
    footerTextColor: white,
    cartHeaderBackgroundColor: grey,
  },
}
